import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";

export default function NotFound() {
  useSeo({ title: "Page introuvable", description: "Cette page n'existe pas.", path: "/404" });
  return (
    <div className="dl-container py-40 text-center">
      <div className="dl-eyebrow mb-4">Erreur 404</div>
      <h1 className="serif text-5xl md:text-7xl text-[#F3E9D2]">Page introuvable</h1>
      <p className="text-[#F3E9D2]/60 mt-5">Le chemin que vous cherchez s'est perdu entre deux pages d'un vieux grimoire.</p>
      <Link to="/" className="dl-btn dl-btn-solid mt-8">Retour à l'accueil</Link>
    </div>
  );
}
